import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Season } from '@coin/shared/season-mgmt/util';
import { HttpHelpersService, LoadingService } from '@coin/shared/core/data-access';
import { SeasonProcessState, SeasonTypeEnum } from '@coin/shared/core/util-enums';
import { environment } from '@coin/shared/core/util-environments';
import { encodeSeasonType } from '@coin/shared/core/util-helpers';
import { PaginatedResult, SimpleTableService } from '@coin/shared/core/util-models';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SpecialPaymentSeasonService implements SimpleTableService {
  private readonly httpClient = inject(HttpClient);
  private readonly loadingService = inject(LoadingService);
  private readonly httpHelpersService = inject(HttpHelpersService);

  public queryPagedAndFilteredData = (page: number, size: number): Observable<PaginatedResult<Season>> =>
    this.getSeasons(page, size);

  public updateSeasonState(
    id: string,
    newState: SeasonProcessState.Evaluation | SeasonProcessState.Monitoring
  ): Observable<Season> {
    return this.loadingService.withLoadingScreen(
      this.httpClient
        .patch<Season>(`${environment.api.baseUrl}/admin/api/v3/master/seasons/special-payment/${id}/update-state`, {
          state: newState
        })
        .pipe(this.httpHelpersService.handleError('Error updating season'))
    );
  }

  private getSeasons(page: number, size: number): Observable<PaginatedResult<Season>> {
    return this.httpClient
      .get<
        PaginatedResult<Season>
      >(`${environment.api.baseUrl}/admin/api/v1/${encodeSeasonType(SeasonTypeEnum.SpecialPayment)}/seasons?page=${page + 1}&size=${size}&seasonType=${SeasonTypeEnum.SpecialPaymentCash}&seasonType=${SeasonTypeEnum.SpecialPaymentEquity}`)
      .pipe(catchError(() => of(null)));
  }
}
